var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartMinimum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 2C3.03486 2 3.33333 2.29848 3.33333 2.66667V11.3333C3.33333 12.0697 3.93029 12.6667 4.66667 12.6667H13.3333C13.7015 12.6667 14 12.9651 14 13.3333C14 13.7015 13.7015 14 13.3333 14H4.66667C3.19391 14 2 12.8061 2 11.3333V2.66667C2 2.29848 2.29848 2 2.66667 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33317 2C5.70136 2 5.99984 2.29848 5.99984 2.66667C5.99984 4.62793 6.24726 6.52715 6.82356 7.91026C7.39655 9.28545 8.21484 10 9.33317 10C10.4515 10 11.2698 9.28545 11.8428 7.91026C12.4191 6.52715 12.6665 4.62793 12.6665 2.66667C12.6665 2.29848 12.965 2 13.3332 2C13.7014 2 13.9998 2.29848 13.9998 2.66667C13.9998 4.7054 13.7473 6.80618 13.0736 8.42308C12.3966 10.0479 11.2148 11.3333 9.33317 11.3333C7.4515 11.3333 6.26979 10.0479 5.59279 8.42308C4.91908 6.80618 4.6665 4.7054 4.6665 2.66667C4.6665 2.29848 4.96498 2 5.33317 2Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMinimum);
export default __webpack_public_path__ + "static/media/chart-minimum.c380559f91ac743bc55926cdb6eee075.svg";
export { ForwardRef as ReactComponent };